module.exports = __webpack_public_path__ + "img/slovenia.af560a54.png";